var App = App || {};

App.LoanOfficerSearch = (function ($) {
    'use strict';

    function init() {

        $(".locations-form").on("click keypress", function () {
            if ($('.locations-form').hasClass("ng-invalid")) {
                setTimeout(function () {
                    $(".locationsModule .locations-form .invalid-feedback:visible").each(function () {
                        $(this).closest(".form-group").find("input").focus();
                    });
                }, 100);
            }
        });
    }


    return {
        init: init
    };
})(jQuery);

$(function () {
    App.LoanOfficerSearch.init();
});
